import React, { useState } from "react";
import { notification, Card } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { usePermissions } from "../../PermissionsProvider";
import { SentinelService } from "../../services/SentinelService";
import NewSentinelForm from "./NewSentinelForm";

const RegisterSentinel: React.FC = () => {
  const navigate = useNavigate();
  const { apiKey } = usePermissions();
  const { intentGroupId } = useParams();
  const [loading, setLoading] = useState(false);
  const [qa, setQa] = useState<any>(null);
  const [hasSubmitted, setHasSubmitted] = useState(false);

  const handleSubmit = (formData: { 
    expectation: string; 
    condition: string; 
    qa?: any;
  }) => {
    setLoading(true);    
    const sentinelData: {
      intent_group_id: number;
      expectation: string;
      condition: string;
      qa?: any;
    } = {
      intent_group_id: Number(intentGroupId),
      expectation: formData.expectation,
      condition: formData.condition,
      qa: formData.qa,
    };

    SentinelService.generateSentinel(sentinelData, setLoading, apiKey).subscribe(
      (response: any) => {
        setHasSubmitted(true);
        const sentinels = response.sentinels;
        const newQa = response.user_prompts;
        if (newQa && newQa.length > 0) {
          // There are questions that the user needs to answer
          setQa(qa ? [...qa, ...newQa] : newQa);
        } else if (sentinels && sentinels.length > 0) {
          const createdSentinel = sentinels[0];
          notification.success({
            message: "Success",
            description: "Sentinel registered successfully",
          });
          navigate(`/intent-group/${intentGroupId}/sentinel/${createdSentinel.id}`);
        }
      },
      (error: any) => {
        console.error(error);
        notification.error({
          message: "Error",
          description: "Failed to generate Sentinel",
        });
        setLoading(false);
      }
    );
  };

  const handleClose = () => {
    navigate(-1);
  };

  return (
    <div style={{ maxWidth: "900px", margin: "0 auto" }}>
      <Card
        title="Generate New Sentinel"
        extra={<CloseOutlined onClick={handleClose} style={{ cursor: "pointer" }} />}
        style={{ width: "100%" }}
      >
        <NewSentinelForm
          loading={loading}
          onSubmit={handleSubmit}
          onClose={handleClose}
          qaItems={qa}
          setQaItems={setQa}
          hasSubmitted={hasSubmitted}
        />
      </Card>
    </div>
  );
};

export default RegisterSentinel;
